import {Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Paper} from '@mui/material';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Draggable from 'react-draggable';
import { useDispatch, useSelector } from 'react-redux';
import { setIsBasicFilterActive, setIsCustomFilterActive } from '../redux/slices/filterSlice';
import FilterPanel from './FilterPanel';
import { appBarStyle } from '../utils/StyleHelper';
import CloseIcon from "@mui/icons-material/Close";
import ColorConstants from "../defaults/ColorConstants";

export default function WorkflowFilterContainer({isOpen, setIsOpen, userInfo, setIsCreatingPlannedFeature, setIsCreatingActualFeature}) {
  const dispatch = useDispatch();
  const nodeRef = useRef(null);
  const [filterPanelPosition, setFilterPanelPosition] = useState({ x: 0, y: 0 });
  const config = useSelector((state) => state.configuration.config);
  const isCustomFilterActive = useSelector((state) => state.filter.isCustomFilterActive);

  const dispatchIsBasicFilterActive = useCallback(args => {
    dispatch(setIsBasicFilterActive(args));
  }, [dispatch]);

  const dispatchIsCustomFilterActive = useCallback(args => {
    dispatch(setIsCustomFilterActive(args));
  }, [dispatch]);

  useEffect(() => {
    dispatchIsBasicFilterActive(!isCustomFilterActive);
    dispatchIsCustomFilterActive(!!isCustomFilterActive);
  }, [dispatchIsBasicFilterActive, dispatchIsCustomFilterActive, isCustomFilterActive]);

  const handleStop = useCallback((event, dragElement) => {
    event.preventDefault();
    if (
      nodeRef.current &&
      (filterPanelPosition.x !== dragElement.x || filterPanelPosition.y !== dragElement.y)
    ) {
      setFilterPanelPosition({ x: dragElement.x, y: dragElement.y });
    }
  }, [filterPanelPosition]);

const PaperComponent = useCallback(function PaperComponent(props) {
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
      position={filterPanelPosition}
      onStop={handleStop}
    >
      <Paper {...props} ref={nodeRef} style={{ overflow: 'auto', resize: 'both',pointerEvents: "auto" }} />
    </Draggable>
  );
}, [filterPanelPosition, handleStop]);
const handleClose = () => {
        setIsOpen(false)
    };
  return (
    <Dialog
      PaperComponent={PaperComponent}
      open={isOpen}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") setIsOpen(false);
      }}
      hideBackdrop={true}
      style={{ pointerEvents: "none" }}
    >
     <DialogTitle style={{ ...appBarStyle(config), cursor: 'move' }} id="draggable-dialog-title">
        Filters
        <IconButton
        edge="start"
        color="inherit"
        onClick={handleClose}
        aria-label="close"
         style={{ pointerEvents: "auto" }}
        >
          <CloseIcon style={{ fill: ColorConstants.WhiteAlien }} />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{paddingLeft: '5px', paddingRight: '5px', paddingTop: '5px', pointerEvents: "auto"}}>
        <FilterPanel
          setIsBasicFilterActive={setIsBasicFilterActive}
          setIsCustomFilterActive={setIsCustomFilterActive}
          setIsCreatingActualFeature={setIsCreatingActualFeature}
          setIsCreatingPlannedFeature={setIsCreatingPlannedFeature}
          userInfo={userInfo}
        />
      </DialogContent>
      <DialogActions/>
    </Dialog>
  )
}